import { Component, OnInit } from '@angular/core';
import { EOrdenacao } from '../../../shared/data/ordenacao.enum';
import { ISetup, IListByFilterSetups } from '../models/setup.interface';
import { SessionService } from '../../../shared/services/session.service';
import { SetupService } from '../services/setup.service';
import { UntypedFormControl } from '@angular/forms';
import { ICompany } from '../../companies/models/company.interface';
import { CompanyService } from '../../companies/services/company.service';
import { ERoleAdminString } from '../../../shared/data/role.enum';

@Component({
  selector: 'app-setups',
  templateUrl: './setups.component.html',
  styleUrls: ['./setups.component.scss']
})
export class SetupsComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };
  formInput = new UntypedFormControl();
  orderControl = new UntypedFormControl(1);
  companyControl = new UntypedFormControl();
  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  setups: ISetup[] = [];

  companies: ICompany[] = [];

  constructor(
    private readonly setupService: SetupService,
    private readonly sessionService: SessionService,
    private readonly companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.getSetups();
    this.orderControl.valueChanges.subscribe((orderSelected: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = orderSelected;
      this.getSetups();
    });

    // Só Admin escolhe a empresa; os demais veem a da sessão e não têm company.list.
    if (this.sessionService.getSession().role === ERoleAdminString.Admin) {
      this.companyService.listarEmpresasAtivas().subscribe((response) => {
        this.companies = response.data;
      });
    }

    this.companyControl.valueChanges.subscribe(() => {
      this.getSetups();
    });
  }

  public getSetups(): void {
    const companyId = this.sessionService.getSession().companyId;

    const filter: IListByFilterSetups = {
      pageNumber: this.dadosPaginacao.paginaSelecionada,
      pageSize: this.dadosPaginacao.tamanhoPagina,
      orderBy: this.dadosPaginacao.ordenacao
    };

    const companyIdFilter = companyId || this.companyControl.value;

    if (companyIdFilter) {
      filter.companyId = String(companyIdFilter);
    }

    if (this.formInput.value) {
      filter.searchText = String(this.formInput.value);
    }

    this.setupService.listSetups(filter).subscribe((resposta) => {
      this.setups = resposta.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = resposta.count!;
    });
  }

  public cleanForm(): void {
    this.formInput.reset();
    this.companyControl.reset();
    this.getSetups();
  }

  public filterSetups(): void {
    this.getSetups();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.getSetups();
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.getSetups();
  }
}
